import React, { useState, useEffect } from 'react'
import { isEmpty } from 'ramda'
import {
  getTextByLang
} from '../../ExternalFields'
import { useStore } from '../../../StateProvider'
import { getExternalFieldsList, getIsExtFldsValid, sortExtFlds } from '../tierFormUtils'
import { FormWithoutSteps } from '../FormWithoutSteps/FormWithoutSteps'
import styles from '../style.css'

const TierFormNoSteps = ({ isLoadingSubmit, onSubmit, buttonName }) => {
  const [{
    whitelabel: { extFields, customTexts, questionnaireTier },
    validation, validation: { tier }, form: { accId },
    user: { questionnairePassed }
  }] = useStore()
  const [fieldsDescription, setFieldsDescription] = useState([])
  const [fields, setFields] = useState([])
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    if (isEmpty(fieldsDescription) || !tier) {
      return
    }
    setIsValid(getIsExtFldsValid(validation[`tier${tier}`][accId], fieldsDescription))
  }, [validation, fieldsDescription])

  useEffect(() => {
    if (!tier) return
    /**
     * @type {ExternalField[]}
     */
    let fldDescriptions = extFields.filter(fld => fld.tier === tier)
    if (questionnaireTier === tier && questionnairePassed) {
      fldDescriptions = fldDescriptions.filter(fld => fld.type !== 'questionnaireSelect')
    }
    setFieldsDescription(fldDescriptions)
    const flds = sortExtFlds(getExternalFieldsList(fldDescriptions))
    setFields(flds)
  }, [extFields, tier])

  const onFormSubmit = () => {
    onSubmit().catch(() => {})
  }

  return fields.length ? (
    <>
      <FormWithoutSteps
        fields={fields}
        isButtonDisabled={!isValid || isLoadingSubmit}
        onSubmit={onFormSubmit}
        isLoadingSubmit={isLoadingSubmit}
        buttonName={buttonName}
      />
      <div className={styles.additionalText}>
        {getTextByLang('additionalConditions', customTexts)}
      </div>
    </>
  ) : null
}

export { TierFormNoSteps }
